import React, { useEffect, useState } from "react";
import { pdpApiInstance } from "../../axiosInstances";
import { useLocation, useNavigate } from "react-router-dom";
import ReviewplaylistTable from "./ReviewplaylistTable";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import axios from "axios";

const PlaylistReview = ({ getPlaylist, showsearch }) => {
  const [loading, setLoading] = useState(false);
  const [reviewVideos, setReviewVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalVideos, setTotalVideos] = useState(0);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const cdnUrl = process.env.REACT_APP_S3_CDN;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const user = useSelector((state) => state.auth.user);

  const setCreateModeratorPlaylist = (value) => {
    searchParams.set("CreateModeratorPlaylist", value);
    navigate({ search: searchParams.toString() });
  };
  const submitModeratorPlaylist = (value) => {
    searchParams.set("ModeratorPlaylistSubmit", value);
    navigate({ search: searchParams.toString() });
  };

  const PlaylistSubmited =
    searchParams.get("ModeratorPlaylistSubmit") === "true";

  const formatVideoDuration = (durationInSeconds) => {
    const minutes = Math.floor(durationInSeconds / 60);
    const seconds = Math.floor(durationInSeconds % 60);
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${formattedMinutes}:${formattedSeconds}`;
  };
  const toggleVideoSelection = (video) => {
    setSelectedVideos((prevSelected) => {
      if (prevSelected.includes(video)) {
        return prevSelected.filter((v) => v !== video);
      } else {
        return [...prevSelected, video];
      }
    });
  };

  const fetchData2 = async (pageNumber, tag) => {
    // if (tag !== "viewmore") {
    //   setLoading(true);
    //   // Reset the page number to 1 and clear the existing videos if not loading more
    //   if (pageNumber === 1) {
    //     setReviewVideos([]); // Clear the existing videos
    //   }
    // }

    try {
      const res = await axios.get(
        `  ${process.env.REACT_APP_API_URL_PDP}/api/moderator/videos/product-title?title=${showsearch}`,
        {
          params: {},

          headers: {
            Authorization: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "",
          },
        }
      );

      // If loading more videos, append them to the existing list
      // If not, replace the list with the new data
      //   if (tag === "viewmore") {
      //     setReviewVideos((prevVideos) => [
      //       ...prevVideos,
      //       ...res.data.data.records,
      //     ]);
      //   } else {
      setReviewVideos(res.data.data);
      //     setPage(1); // Reset the page number after applying a filter
      //   }

      // setTotalVideos(res.data.data.count);

      if (tag !== "viewmore") {
        setTimeout(() => {
          setLoading(false);
        }, 700);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
      //   if (tag !== "viewmore") {
      //     setTimeout(() => {
      //       setLoading(false);
      //     }, 700);
      //   }
    }
  };
  function generateRandomCode(length = 8) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
  }

  const handleSubmit = async () => {
    const payload = {
      brandId: user.brand_id,
      playlistName: "All Video Playlist",
      code: generateRandomCode(),
      videos: selectedVideos.map((video, index) => ({
        id: video.id,
        order: index + 1,
      })),
    };

    try {
      const response = await axios.post(
        `  ${process.env.REACT_APP_API_URL_PDP}/api/playlists`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "",
          },
        }
      );

      toast.success("Created Successfully");
      getPlaylist();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to create playlist");
    }
  };

  useEffect(() => {
    fetchData2();
  }, [showsearch]);

  if (PlaylistSubmited) {
    return <ReviewplaylistTable />;
  }

  return (
    <div className="h-100">
      <div
        className="d-flex flex-wrap p-0"
        style={{ height: "calc(100% - 50px)", overflow: "auto" }}
      >
        {reviewVideos.length > 0 ? (
          <>
            {reviewVideos.map((video) => (
              <div
                key={video.id}
                className="col-2 mt-3"
                style={{ position: "relative" }}
              >
                <div className="p-2">
                  <label
                    className="playlist w-100"
                    style={{
                      boxShadow: "0.3px 0.3px 2px 1px #E8E8E8",
                      borderRadius: "10px",
                      borders: "5px 5px 0 5px",
                      outline: selectedVideos.some((el) => el.id === video.id)
                        ? "5px solid #334499"
                        : "none",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedVideos.some((el) => el.id === video.id)}
                      onChange={() => toggleVideoSelection(video)}
                      style={{ zIndex: "1" }}
                    />
                    <div className="position-relative">
                      <img
                        className="h-100"
                        src={
                          video.coverImage
                            ? `${cdnUrl}${video.coverImage}`
                            : video.coverImage
                        }
                        style={{
                          borderRadius: "10px 10px 0 0",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      {/* <video
                    className="h-100 w-100"
                    style={{
                      borderRadius: "10px 10px 0 0",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  >
                    <source
                      src={
                        video.assetKey
                          ? `${cdnUrl}${video.assetKey}`
                          : video.assetKey
                      }
                    />
                  </video> */}
                      <div
                        className="badge position-absolute mb-4 m-1 p-1"
                        style={{
                          bottom: "30px",
                          right: "10px",
                          backgroundColor: "rgba(23, 23, 28, 0.7)",
                        }}
                      >
                        {formatVideoDuration(video.duration)}
                      </div>
                      <div
                        className="title_video_select"
                        style={{
                          paddingLeft: "10px",
                          paddingTop: "3px",
                          paddingBottom: "6px",
                        }}
                      >
                        {video.title ? video.title : "No-Title"}
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            ))}
          </>
        ) : (
          <p style={{ margin: "auto" }}>No video found</p>
        )}
      </div>
      <div className="d-flex gap-2 mt-3">
        <button
          className="btn btn-light"
          style={{
            color: "rgba(51, 68, 153, 1)",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setCreateModeratorPlaylist(false);
          }}
        >
          Back
        </button>
        <button
          className="btn btn-dark"
          onClick={() => {
            submitModeratorPlaylist(true);
            handleSubmit();
          }}
          disabled={selectedVideos.length == 0}
        >
          Create
        </button>
      </div>
    </div>
  );
};

export default PlaylistReview;
